import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import './BorderBlueButtonV2.scss';

export default function BorderBlueButtonV2(props){

    const className = 'button__borderBlueButtonV2';

    return (
        <button onClick={props.onClick} className={className + (props.disabled ? '__disabled' : '') + ' width-wfa'} disabled={props.disabled}>
            {props.text}
        </button>
    );
}
